import { render, staticRenderFns } from "./AddressViewer.vue?vue&type=template&id=3ea049ef&scoped=true&"
import script from "./AddressViewer.vue?vue&type=script&lang=js&"
export * from "./AddressViewer.vue?vue&type=script&lang=js&"
import style0 from "./AddressViewer.vue?vue&type=style&index=0&id=3ea049ef&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea049ef",
  null
  
)

export default component.exports